<div class="flex flex-col gap-[40px]" *transloco="let t; read: 'home'">
  <div class="main-section" @inOutAnimation>
    <div class="w-full h-full pl-5 pr-5 md:pl-52 pt-20 pb-16 text-color-white flex bg-blue1 bg-opacity-30">
      <div class="basis-[500px]">
        <div class="pb-6 title-text">
          <h1>
            {{ t('main-title.title.up') }} <br>
            {{ t('main-title.title.down') }}
          </h1>
        </div>
        <div class="line bg-white"></div>
        <h3 class="pb-8 pt-4 title-text">
          {{ t('main-title.subtitle') }}
        </h3>
        <a [routerLink]="'/home-calculator'">
          <div
            class="py-4 px-6 bg-blue2 text-white rounded border-2 border-white flex items-center justify-center w-fit hover:bg-blue3 transition ease-in-out">
            <i class="pvsc-icon text-[30px] mr-6 icon-home"></i>
            <div class="text-xl font-semibold">{{ t('calculator.subtitle') }}</div>
          </div>
        </a>
      </div>
    </div>
  </div>

  <a href="https://www.otpbanka.hr/gradani/suncani-kredit" target="_blank" class="w-full flex justify-center"
     @inOutAnimation>
    <img src="assets/images/OTP_suncani_kredit.png" alt="OTP Suncani Kredit banner">
  </a>

  <div class="bg-blue3 text-color-white flex-col flex p-12 gap-10 md:flex-row justify-center">
    <img src="assets/images/inspector_panel.webp" alt="Person inspecting solar panel">
    <div class="flex flex-col gap-6 w-full md:w-1/3 xl:w-1/4">
      <i class="pvsc-icon icon-sun text-4xl"></i>
      <h1>{{t('ready.title')}}</h1>
      <div class="text-xl">{{t('ready.subtitle')}}</div>
    </div>
  </div>

  <div class="flex flex-col justify-center items-center w-2/3 self-center gap-10">
    <psc-section-title [title]="t('how_it_works.title')"></psc-section-title>
    <div class="grid auto-rows-fr grid-flow-row md:auto-cols-fr md:grid-flow-col gap-10">
      <psc-info-card
        [title]="t('how_it_works.calculate.title')"
        [text]="t('how_it_works.calculate.subtitle')"
        icon="statistics"></psc-info-card>
      <psc-info-card
        [title]="t('how_it_works.plan.title')"
        [text]="t('how_it_works.plan.subtitle')"
        icon="analysis"></psc-info-card>
      <psc-info-card
        [title]="t('how_it_works.connect.title')"
        [text]="t('how_it_works.connect.subtitle')"
        matIcon="psc-network"></psc-info-card>
      <psc-info-card
        [title]="t('how_it_works.pay.title')"
        [text]="t('how_it_works.pay.subtitle')"
        matIcon="psc-payment"></psc-info-card>
      <psc-info-card
        [title]="t('how_it_works.save.title')"
        [text]="t('how_it_works.save.subtitle')"
        matIcon="psc-processes"></psc-info-card>
    </div>
  </div>

  <div
    class="font-bold text-2xl md:text-5xl text-color-white bg-blue2 grid-patter-bg text-center py-8 px-14 md:py-20 md:px-32">
    {{ t('app_info') }}
  </div>

  <div class="w-2/3 self-center flex flex-col items-center">
    <psc-section-title [title]="t('advantages.title')" [subtitle]="''"></psc-section-title>
    <div class="grid auto-rows-fr grid-flow-row md:auto-cols-fr md:grid-flow-col gap-5">
      <psc-info-card
        [title]="t('advantages.savings.title')"
        [text]="t('advantages.savings.subtitle')"
        image="modern-house-panels.webp"></psc-info-card>
      <psc-info-card
        [title]="t('advantages.property_value.title')"
        [text]="t('advantages.property_value.subtitle')"
        image="man-worker-hands-wide.webp"></psc-info-card>
      <psc-info-card
        [title]="t('advantages.eco.title')"
        [text]="t('advantages.eco.subtitle')"
        image="solar-panels-roof-green.webp"></psc-info-card>
    </div>
  </div>

  <psc-most-frequent-questions></psc-most-frequent-questions>

</div>
